import '../css/module_forchange.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import {
  showSpinner, 
  hideSpinner, 
  alertNotification, 
  sentryAPIError
} from './module_common';
import {configSkillBooksCarousel} from './module_skill-books-carousel';
import { initCardLazyLoad } from './module_lazyload';
import { openModal } from './module_modal';

import './module_common_actions';

const formId = "4changeForm";
const submitId = "4changeformsubmit";
const formContainerSelector = "#4change-form-container";

function goToForm(){
  const el = $(formContainerSelector)
  const navbarHeight = 80
  $('html').animate({
    scrollTop: (el.offset().top - navbarHeight)
  }, 800);
  
}

function onSubmit(){
  const formEl = document.getElementById(formId)
  let formData = new FormData(formEl)
  
  const ep = "/it/_ajax/4change/ajform"
  fetch(ep, {
      method: 'POST',
      body: new URLSearchParams(formData)
  }).then((resp) => {
      enableSubmit()
      hideSpinner()
      return resp.json()
  }).then((body) => {
      if (body.ok) {
        grecaptcha.reset()
        formEl.reset()
        formEl.classList.remove('was-validated');
        openModal('#MailSubmittedModal', "onSubmit")
      }else{
        grecaptcha.reset()
        alertNotification(messages['genericApiError'])
        sentryAPIError(ep, "Server returns ok: false", formData, '4changeSubmitForm');
      }
      
  }).catch((error) => {
    alertNotification(messages['genericApiError'])
    sentryAPIError(ep, error, formData, '4changeSubmitForm');
  });
}

function attachSubmitEventToForm(){
  const formEl = document.getElementById(formId)
  formEl.addEventListener('submit', function(event) {
    event.preventDefault();
    event.stopPropagation();
    if (formEl.checkValidity() === false) {
      formEl.classList.add('was-validated');
    }else{
      disableSubmit()
      showSpinner()
      grecaptcha.execute()
    }
  }, false);
}

function disableSubmit(){
  document.getElementById(submitId).disabled = true
}

function enableSubmit(){
  document.getElementById(submitId).disabled = false
}

function attachGoToFormClick(){
  const el = $(".goto-form-attach-clk")
  el.on('click', goToForm)
}

window.onSubmit = onSubmit

$(function () {
  // leavingUserModal not shown because we dont call initNavbar
  initFirebaseApp()
  doLast()
  initCardLazyLoad()
  configSkillBooksCarousel()

  grecaptcha.ready(function(){
    enableSubmit()
  })

  attachSubmitEventToForm()
  attachGoToFormClick()
});